import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Headlines from "./components/Headlines";
import Exclusive from "./components/Exclusive";
import FlashTimeline from "./components/FlashTimeline";
import HotRank from "./components/HotRank";
import Categories from "./components/Categories";
import Faq from "./components/Faq";
import About from "./components/About";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackTop from "./components/BackTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-paper">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <Headlines />
        <Exclusive />
        <FlashTimeline />
        <HotRank />
        <Categories />
        <Faq />
        <About />
        <Newsletter />
      </main>
      <Footer />
      <BackTop />
    </div>
  );
}